var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 21.768L4.116 10.885l1.768-1.768L15 18.233l9.116-9.116 1.768 1.768L15 21.768z",
    fill: "#ED6725"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIiBmaWxsPSJub25lIj4KICAgIDxwYXRoIGQ9Ik0xNSAyMS43Njg0TDQuMTE2MjEgMTAuODg0N0w1Ljg4MzcxIDkuMTE3MTlMMTUgMTguMjMzNEwyNC4xMTYyIDkuMTE3MTlMMjUuODgzNyAxMC44ODQ3TDE1IDIxLjc2ODRaIiBmaWxsPSIjRUQ2NzI1Ii8+Cjwvc3ZnPgo=";
export { SvgArrowDown as ReactComponent };